import type { MyApplications } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const getMyApplications = async (): Promise<MyApplications> => {
  const response = await apiClient.get<MyApplications>('/me/applications');
  return response.data;
};
